(function () {
  var start = function () {
    var root = document.getElementById('cc-wd-edu');
    if (!root) return;
    if (root.parentNode !== document.body) document.body.appendChild(root);

    var dialog = root.querySelector('.cc-wd-edu__dialog');
    var panels = root.querySelectorAll('[data-cc-wd-edu-panel]');
    var lastFocus = null;

    var showPanel = function (id) {
      var isGuide = id === 'guide';
      root.classList.toggle('is-guide', isGuide);
      panels.forEach(function (panel) {
        var heading = panel.querySelector('h2');
        if (heading && heading.id === 'cc-wd-edu-live-title') heading.removeAttribute('id');
        if (panel.getAttribute('data-cc-wd-edu-panel') === id) {
          panel.removeAttribute('hidden');
          if (heading) heading.id = 'cc-wd-edu-live-title';
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      var scroll = root.querySelector('.cc-wd-edu__scroll');
      if (scroll) scroll.scrollTop = 0;
    };

    var open = function (id) {
      if (!id) return;
      lastFocus = document.activeElement;
      showPanel(id);
      root.classList.add('is-open');
      root.removeAttribute('hidden');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cc-wd-edu-open');
      if (dialog) dialog.focus();
    };

    var close = function () {
      if (root.hasAttribute('hidden')) return;
      root.classList.remove('is-open');
      root.setAttribute('hidden', '');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cc-wd-edu-open');
      root.classList.remove('is-guide');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    document.addEventListener('click', function (event) {
      var goto = event.target.closest('[data-cc-wd-edu-goto]');
      if (goto) {
        event.preventDefault();
        close();
        var target = document.getElementById(goto.getAttribute('data-cc-wd-edu-goto'));
        if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var opener = event.target.closest('[data-cc-wd-edu-open]');
      if (opener) {
        event.preventDefault();
        event.stopPropagation();
        open(opener.getAttribute('data-cc-wd-edu-open'));
        return;
      }
      if (event.target.closest('[data-cc-wd-edu-close]')) {
        event.preventDefault();
        close();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    var printBtn = root.querySelector('[data-cc-wd-edu-print]');
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        open('guide');
        window.setTimeout(function () {
          window.print();
        }, 50);
      });
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
